import { ReactElement, useState } from 'react';
import { useWebSocket } from 'helpers/wsConnection';
import { useTranslation } from 'react-i18next';

interface EnvironmentTemperatureItemProps {
  readonly deviceCode: string;
}

export function EnvironmentTemperatureItem({
  deviceCode,
}: EnvironmentTemperatureItemProps): ReactElement {
  const { t } = useTranslation();

  const [temperature, setTemperature] = useState<number>();

  function onWsOpen(wsConn): void {
    wsConn.send({ type: 'dutSubscribeRealTime', data: { DUT_ID: deviceCode } });
  }

  function onWsMessage(payload): void {
    if (payload.type === 'dutTelemetry' && payload.data.dev_id === deviceCode) {
      setTemperature(payload.data.Temperature);
    }
  }

  function beforeWsClose(wsConn): void {
    wsConn.send({ type: 'dutUnsubscribeRealTime' });
  }

  useWebSocket(onWsOpen, onWsMessage, beforeWsClose);

  return (
    <li>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <p>{t('temperaturaDoAmbiente')}</p>
        <div style={{
          marginLeft: 'auto', display: 'flex', gap: '8px', justifySelf: 'self-end',
        }}
        >
          <span>{`${temperature ?? '-'}°C`}</span>
        </div>
      </div>
    </li>
  );
}
